import { ExclamationCircleOutlined } from "@ant-design/icons";
import FormBuilderSaveButton from "./FormBuilderSaveButton";
import CustomPopconfirm from "../Popover/CustomPopconfirm";
import scrollToFieldIfVisible from "../../utils/scrollToFieldIfVisible";

interface UpdateClosedReportButtonProps {
	form: any;
	isSavingOrLoading: boolean;
	handleUpdate: () => void;
	status?: string | null;
	onValidationError?: (error: unknown) => void;
	onValidationSuccess?: () => void;
}

function UpdateClosedReportButton({
	form,
	isSavingOrLoading,
	handleUpdate,
	status,
	onValidationError,
	onValidationSuccess,
}: UpdateClosedReportButtonProps) {
	const isClosed = status === "closed";

	const handleConfirm = async () => {
		try {
			await form.formRef.validateFields();
			onValidationSuccess?.();
			handleUpdate();
		} catch (error: any) {
			if (error?.errorFields?.length > 0) {
				const firstError = error.errorFields[0];
				const fieldName = Array.isArray(firstError.name)
					? firstError.name
					: [firstError.name];

				scrollToFieldIfVisible(form.formRef, fieldName, {
					behavior: "smooth",
					block: "center",
				});

				const fieldElement = document.querySelector(
					`[name="${fieldName.join(".")}"], [id="${fieldName.join(".")}"]`
				);
				if (fieldElement) {
					fieldElement.classList.add("custom-field-error");
					setTimeout(() => {
						fieldElement.classList.remove("custom-field-error");
					}, 3000);
				}
			}
			if (onValidationError) {
				onValidationError(error);
			}
		}
	};

	return (
		<CustomPopconfirm
			title={
				<div className="max-w-2xs p-2.5 text-justify">
					{isClosed
						? "You are updating a closed report. This action will modify the report data."
						: "You are saving changes to this report. The workflow status will remain unchanged."}
				</div>
			}
			handleConfirm={handleConfirm}
		>
			<FormBuilderSaveButton
				form={form}
				labelText="Update"
				disabled={!form.isDirty || isSavingOrLoading}
			/>
		</CustomPopconfirm>
	);
}

export default UpdateClosedReportButton;
